import React, { useState, useMemo, useEffect } from 'react'; // Added useEffect
import { Link } from 'react-router-dom';
// We can reuse the main landing page CSS for a lot of the base styling
import styles from './LandingPage.module.css'; 
// We'll create a dedicated CSS file for the new, unique components
import resourceStyles from './ResourcesHubPage.module.css';
import imageLogo from "../../assets/images/BSPLogoTranSmall.png";

// Import icons
import { FaSearch, FaChevronDown, FaLightbulb, FaClipboardList, FaUserCheck, FaBars, FaTimes } from 'react-icons/fa'; // Added FaBars and FaTimes

// --- DATA: This is your provided content, structured for React ---
const constructionStages = [
    { name: 'Planning & Design', color: '#D1E8FF', description: 'Consultants are engaged to compile the required drawings and specifications for the project.' },
    { name: 'Pre-Commencement', color: '#FFF3CD', description: 'Documents are compiled and finalized, ready for procurement and the start of construction.' },
    { name: 'Procurement', color: '#D4EDDA', description: 'The tendering process for engaging the primary contractor to carry out the building works.' },
    { name: 'Construction', color: '#F8D7DA', description: 'The main building phase of the project, where the structure is physically built.' },
    { name: 'Post Construction', color: '#E2D9F3', description: 'The final phase involving mandatory inspections, client handover, and fixing any defects.' },
];

const professionalsData = [
    // Planning & Design
    { name: 'Architect', definition: 'Qualified & Registered to produce schematic designs and specifications for the project.', stage: 'Planning & Design' },
    { name: 'Draftsman', definition: 'Qualified to produce schematics and assist Architects with compiling documents for the project.', stage: 'Planning & Design' },
    { name: 'Land Surveyor', definition: 'Measures property boundaries, site contours, and sets out the proposed building footprint.', stage: 'Planning & Design' },
    { name: 'Quantity Surveyor', definition: 'Provides estimates, cost monitoring, and tax depreciation schedules for projects.', stage: 'Planning & Design' },
    { name: 'Structural Engineer', definition: 'Designs and advises on the building’s structural elements like foundations, frames, and supports.', stage: 'Planning & Design' },
    // ... Add ALL other professionals from your tables here, correctly mapped to their stage
    
    // Procurement
    { name: 'Finance Broker', definition: 'Assists with negotiating finance between the client and lending institutions.', stage: 'Procurement' },
    { name: 'Building Contractor', definition: 'The primary licensed professional engaged to perform the building works for a project.', stage: 'Procurement' },

    // Construction
    { name: 'Concreter', definition: 'Licensed contractor who forms up, mixes, pours & finishes the concrete for a project.', stage: 'Construction' },
    { name: 'Plumber', definition: 'Licensed contractor who supplies and installs the required water, sewer, stormwater and gas.', stage: 'Construction' },
    { name: 'Electrician', definition: 'Licensed contractor who supplies and installs the required power, lighting and communication systems.', stage: 'Construction' },
];

    // Map stages to their colors for easy lookup
    const stageColorMap = constructionStages.reduce((acc, stage) => {
        acc[stage.name] = stage.color;
        return acc;
    }, {});

// --- Sub-Components for the Page ---

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <img
            src={imageLogo}   // Replace with your logo image path
            alt="Build Start Logo"
            style={{ height: '35px', marginRight: '10px' }}  // Adjust size & spacing as needed
          />
          </div>
        <nav className={`${styles.nav} ${isMenuOpen ? styles.navMobile : ''}`}>
          <ul className={styles.navLinks}>
            <li className={styles.closeIcon} onClick={toggleMenu}><FaTimes /></li>
            <li><Link to="/">Home Owner</Link></li>
            <li><Link to="/business-landing">For Professionals</Link></li>
            <li><a href="/for-developers">For Renovators / Developers</a></li>
            <li className={styles.activeLink} ><Link to="/resources-hub" className={styles.activeLink}>Resources Hub</Link></li>
            <li><a href="/contact-support">Support</a></li>
            <li className={styles.mobileAuth}>
              <Link to="/login" className={styles.btnLogin}>Login</Link>
            </li>
            <li className={styles.mobileAuth}>
              <Link to="/select-role" className={styles.btnRegister}>Get Started</Link>
            </li>
          </ul>
        </nav>
        <div className={styles.headerRight}>
          <Link to="/login" className={styles.btnLogin}>Login</Link>
          <Link to="/select-role" className={styles.btnRegister}>Get Started</Link>
        </div>
        <div className={styles.menuIcon} onClick={toggleMenu}>
          <FaBars />
        </div>
      </div>
    </header>
  );
};

const HeroSection = () => (
    // Replaced the old dark hero with the new one consistent with the main landing page
    <section className={resourceStyles.hero}>
        <div className={styles.container}>
            <div className={resourceStyles.heroContent}>
                <h1>Your Project, Demystified.</h1>
                <p>From first idea to final handover, understand every step of the building process. Build with the confidence of an expert.</p>
            </div>
        </div>
    </section>
);

const FirstStepsSection = () => (
    <section className={styles.sectionPadding}>
        <div className={styles.container}>
            <h2 className={styles.sectionTitle}>Don't Know Where to Start? Your First 3 Steps.</h2>
            <div className={styles.howItWorksGrid}>
                <div className={styles.howItWorksStep}>
                    <div className={styles.stepIconWrapper}><FaLightbulb /></div>
                    <h3>1. Define Your Vision & Budget</h3>
                    <p>Before you talk to anyone, get clear on what you want to achieve and what you can afford. Create a scrapbook of ideas and set a realistic budget range.</p>
                </div>
                <div className={styles.howItWorksStep}>
                    <div className={styles.stepIconWrapper}><FaClipboardList /></div>
                    <h3>2. Post Your Job on Build Start</h3>
                    <p>Create a detailed job posting. The more information you provide, the more accurate your quotes will be. It’s free and connects you with a pool of vetted pros.</p>
                </div>
                <div className={styles.howItWorksStep}>
                    <div className={styles.stepIconWrapper}><FaUserCheck /></div>
                    <h3>3. Interview & Vet Professionals</h3>
                    <p>Don't just pick the cheapest quote. Interview at least three professionals. Check their licenses, look at their past work, and speak to their references.</p>
                </div>
            </div>
        </div>
    </section>
);

const RoadmapSection = () => (
    <section className={`${styles.sectionPadding} ${resourceStyles.roadmapSection}`}>
        <div className={styles.container}>
            <h2 className={styles.sectionTitle}>The 5 Key Stages of Construction</h2>
            <div className={resourceStyles.roadmapContainer}>
                {constructionStages.map((stage, index) => (
                    <React.Fragment key={stage.name}>
                        <div className={resourceStyles.roadmapStep}>
                            <div className={resourceStyles.stepNumber} style={{ borderColor: 'black', color: 'black', backgroundColor: stage.color }}>{index + 1}</div>
                            <h4>{stage.name}</h4>
                            <p>{stage.description}</p>
                        </div>
                        {index < constructionStages.length - 1 && <div className={resourceStyles.roadmapConnector}></div>}
                    </React.Fragment>
                ))}
            </div>
        </div>
    </section>
);  
const ProfessionalsDirectory = () => {
    const [selectedStage, setSelectedStage] = useState('All');
    const [searchTerm, setSearchTerm] = useState('');
    const [openFaq, setOpenFaq] = useState(null); // For the FAQ

    const filteredProfessionals = useMemo(() => {
        return professionalsData.filter(prof => {
            const matchesStage = selectedStage === 'All' || prof.stage === selectedStage;
            const matchesSearch = searchTerm === '' || prof.name.toLowerCase().includes(searchTerm.toLowerCase());
            return matchesStage && matchesSearch;
        });
    }, [selectedStage, searchTerm]);

    const commonQuestions = [
        { q: "What's the difference between a Quantity Surveyor and a Land Surveyor?", a: "A Land Surveyor measures the land itself—boundaries, levels, and site features for the design. A Quantity Surveyor (or Cost Estimator) manages the project's finances—they calculate the costs of materials and labor, monitor the budget, and ensure the project is financially viable." },
        { q: "Do I always need an Architect?", a: "For major renovations or new builds, an Architect is invaluable for creating detailed, compliant, and aesthetically pleasing designs. For smaller projects like a simple deck or internal modification, a qualified Draftsman or a design-and-build company might be sufficient." },
        { q: "What is a 'Development Application (DA)'?", a: "A DA is a formal application made to your local council to get approval for a proposed development. It's a critical part of the 'Planning & Design' stage and is usually required for new homes, major extensions, or projects that might impact your neighbours or the environment." },
    {
        q: "How do I create a realistic budget and what are common 'hidden costs'?",
        a: "Start by researching average costs for similar projects in your area. A good rule of thumb is to add a 15-20% contingency fund to your final budget for unexpected issues. Common hidden costs can include council fees, the discovery of asbestos or termites, the need for a switchboard upgrade, or temporary accommodation if you need to move out during major works."
    },
    {
        q: "I have multiple quotes. Why are they so different, and should I just pick the cheapest one?",
        a: "Never choose a quote on price alone. A cheap quote might use lower-quality materials, be missing key items (which will be charged as 'variations' later), or indicate the professional is uninsured or inexperienced. A good quote is detailed and transparent. Compare them line-by-line to see what is included and excluded. The best value is often found in the middle quote from a professional with strong, verified reviews."
    },
    {
        q: "What are the most important things to check before hiring a professional?",
        a: "Beyond the quote, always verify three things: 1) Their Licence: Check with your state's fair trading body to ensure their trade licence is current and valid. 2) Their Insurance: Ask for a copy of their Public Liability Insurance certificate. 3) Their References: Speak to at least two of their recent clients to ask about their communication, timeliness, and the quality of their work. Platforms like Build Start help by pre-vetting many of these details for you."
    },
    {
        q: "Do I need a formal contract for my project?",
        a: "Yes. For any project over a certain value (e.g., $5,000 - this varies by state), a written contract is legally required and protects both you and the professional. For smaller jobs, a detailed written quote that you have both signed and dated can serve as a contract. Never proceed with significant work based on a verbal agreement alone."
    },
    {
        q: "What is a 'variation' and how do I handle changes during the project?",
        a: "A 'variation' is any change to the original scope of work defined in the contract, such as deciding you want different tiles or adding a new power point. To handle them correctly, always get a 'Variation Order' in writing that clearly states the new work to be done and the additional cost. Both you and your contractor must sign it before the new work begins to avoid disputes later."
    },
    {
        q: "How long does a typical bathroom or kitchen renovation take?",
        a: "This varies greatly, but as a general guide, a standard bathroom renovation can take 2-4 weeks, while a kitchen renovation can take 3-6 weeks from the start of construction. This does not include the 'Planning & Design' phase, which can take several months. Always ask your contractor for a detailed timeline as part of their project plan."
    },
    {
        q: "What is a 'defects liability period' and what are my rights after the job is finished?",
        a: "This is a set period after the project is completed (usually 13 weeks for non-structural issues) during which the contractor is legally obliged to return and fix any defects or problems that arise from their workmanship. Always do a final walkthrough before making your final payment, and document any issues in writing. Reputable professionals will always stand by their work and address these issues promptly."
    }    
    ];

    return (
        <section className={styles.sectionPadding}>
            <div className={styles.container}>
                <h2 className={styles.sectionTitle}>Who's Who in Your Construction Project</h2>
                <p className={styles.subheadline}>Use the filters to discover which professionals you'll need at each stage of your journey.</p>
                
                {/* --- Interactive Filter Bar --- */}
                <div className={resourceStyles.filterBar}>
                    <div className={resourceStyles.filterGroup}>
                        <label>Filter by Project Stage:</label>
                        <select value={selectedStage} onChange={(e) => setSelectedStage(e.target.value)}>
                            <option value="All">All Stages</option>
                            {constructionStages.map(stage => <option key={stage.name} value={stage.name}>{stage.name}</option>)}
                        </select>
                    </div>
                    <div className={resourceStyles.filterGroup}>
                        <label>Search for a Professional:</label>
                        <div className={resourceStyles.searchInput}>
                            <FaSearch />
                            <input type="text" placeholder="e.g., Plumber" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                        </div>
                    </div>
                </div>

                {/* --- Professionals Grid --- */}
                <div className={resourceStyles.professionalsGrid}>
                    {filteredProfessionals.map(prof => (
                        <div key={prof.name} className={resourceStyles.professionalCard}>
                            <h4>{prof.name}</h4>
                            <p>{prof.definition}</p>
                            <span className={resourceStyles.stageTag}>{prof.stage}</span>
                        </div>
                    ))}
                </div>

                 {/* --- ADDED CONTENT: Common Questions --- */}
                <div className={resourceStyles.faqSection}>
                    <h2 className={styles.sectionTitle}>Common Questions</h2>
                     {commonQuestions.map((faq, index) => (
                        <div key={index} className={resourceStyles.faqItem}>
                            <button className={resourceStyles.faqQuestion} onClick={() => setOpenFaq(openFaq === index ? null : index)}>
                                {faq.q}
                                <FaChevronDown className={`${resourceStyles.faqIcon} ${openFaq === index ? resourceStyles.open : ''}`} />
                            </button>
                            {openFaq === index && (
                                <div className={resourceStyles.faqAnswer}>
                                    <p>{faq.a}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const FinalCta = () => (
     <section className={`${styles.finalCta} ${styles.sectionPadding}`}>
        <div className={styles.container}>
            <h2>Feeling More Confident?</h2>
            <p>The next step is to find the right people for the job. Post your project on Build Start and connect with trusted, vetted professionals today.</p>
            <Link to="/select-role" className={styles.btnPrimaryLarge}>
                Post Your Job For Free
            </Link>
        </div>
    </section>
);


// --- Main Page Component ---
const ResourcesHubPage = () => {
    return (
        <>
            <Header />
            <main>
                <HeroSection />
                <FirstStepsSection />
                <RoadmapSection />
                <ProfessionalsDirectory />
                <FinalCta />
            </main>
            {/* You can reuse your existing Footer component here */}
        </>
    );
};

export default ResourcesHubPage;
